import axios from '@/libs/api.request'

export const GetSafetyCode = data => {
  return axios.request({
    url: '/print/local/safety/list',
    params: data,
    method: 'get'
  })
}

export const GetSafetyStorage = data => {
  return axios.request({
    url: '/print/local/safety/storage',
    params: data,
    method: 'get'
  })
}
export const AddSafety = data => {
  return axios.request({
    url: '/print/local/safety/add',
    data,
    method: 'post'
  })
}
export const GetLocalActiveCodeLIst = params => {
  return axios.request({
    url: '/print/local/safety/GetLocalActiveCodeLIst',
    params,
    method: 'get'
  })
}
export const CreateActivationCode = data => {
  return axios.request({
    url: '/print/local/safety/CreateActivationCode',
    data,
    method: 'post'
  })
}
export const GetCheckFileData = data => {
  return axios.request({
    url: '/print/local/safety/GetCheckFileData',
    data,
    method: 'post'
  })
}
